// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607290015/js/" + chunkId + "." + {"44":"71245354","225":"ccaea56a","481":"1960314e","486":"b740c9a4","770":"9833c2e3"}[chunkId] + ".0.6069143020228636.chunk.js";
};